import { render } from "./FlashcardDisplay.vue?vue&type=template&id=2839d8bc&scoped=true"
import script from "./FlashcardDisplay.vue?vue&type=script&lang=js"
export * from "./FlashcardDisplay.vue?vue&type=script&lang=js"

import "./FlashcardDisplay.vue?vue&type=style&index=0&id=2839d8bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2839d8bc"]])

export default __exports__